import axios from 'axios';
import { reportError } from '../../utils/error-handling-service';

const prestaShopUrlBase = 'https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production';

const isTugPrestaShopPath = organisationId => {
  if (organisationId === 'b847c281-d377-4528-a416-303234e382d8') {
    return '/tugenuff';
  }
  return '';
};

const getPrestaShopPath = (discussionId, discountCode, organisationId) => {
  const discountCodePath = discountCode ? `/${discountCode}` : '';
  return `/discussion/${discussionId}/prestashop${isTugPrestaShopPath(organisationId)}/sales${discountCodePath}`;
};

const getPrestaShopOrdersByDiscussionIdUrl = (discussionId, discountCode, organisationId) =>
  `${prestaShopUrlBase}${getPrestaShopPath(discussionId, discountCode, organisationId)}`;

const getPrestaShopOrdersByDiscussionId = ({ discussionId, discountCode, organisationId }) =>
  axios.get(getPrestaShopOrdersByDiscussionIdUrl(discussionId, discountCode, organisationId))
    .then(response => {
      const { data } = response;
      return data;
    }).catch(err => {
      reportError('Unknown error', err);
      return { data: { orders: [], error: err } };
    });

module.exports = {
  getPrestaShopOrdersByDiscussionId,
};




/** WEBPACK FOOTER **
 ** ./src/hocs/has-prestaShop/index.js
 **/